import { useEffect } from 'react';

import { useServiceAppState, useToast } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { getSnackbarInfos } from '../../utils/getSnackbarInfos';

/**
 * 알람을 띄우는 상태를 관리하는 훅입니다.
 * @description
 * - 스낵바 노출이 필요한 상태일 경우 내용에 따라 스낵바를 노출합니다.
 * - 리전이 강제로 정해졌거나, 프로젝트가 강제로 정해졌을 경우가 해당합니다.
 */
const useToastStateEffect = () => {
  const { enqueueToast } = useToast();
  const {
    state: { region, projectName, status, isProjectForced, isRegionForced },
  } = useServiceAppState();

  // 상태에 따라 스낵바 노출
  useEffect(() => {
    if (status !== STATUS_CODE.OK) return;
    if (!projectName || !region) return;
    const snackbarInfos = getSnackbarInfos(projectName, region);

    if (isProjectForced) {
      const { message, key } = snackbarInfos['change_project'];

      enqueueToast(message(), {
        key,
        preventDuplicate: true,
      });
    }

    if (isRegionForced) {
      const { message, key } = snackbarInfos['change_region'];

      enqueueToast(message(), {
        key,
        preventDuplicate: true,
      });
    }
  }, []);
};

export default useToastStateEffect;
